import { lazy } from "react";

const CancellationSummary = lazy(() => import("./Cancellation"));
const CancellationDetailSummary = lazy(() => import("./CancellationDetail"));
const ExportSummary = lazy(() => import("./Export"));
const ExportDetailSummary = lazy(() => import("./ExportDetail"));
const ExportRawSummary = lazy(() => import("./ExportRaw"));
const ExportRawDetailSummary = lazy(() => import("./ExportRawDetail"));
const ImportSummary = lazy(() => import("./Import"));
const ImportDetailSummary = lazy(() => import("./ImportDetail"));
const ImportRawSummary = lazy(() => import("./ImportRaw"));
const ImportRawDetailSummary = lazy(() => import("./ImportRawDetail"));
const InventorySummary = lazy(() => import("./Inventory"));
const InventoryAdjustmentSummary = lazy(() => import("./InventoryAdjustment"));
const OrderSummary = lazy(() => import("./Order"));
const TransferSummary = lazy(() => import("./Transfer"));
const PriceFluctuationDetail = lazy(() => import("./PriceFluctuationDetail"));

export {
  CancellationDetailSummary,
  CancellationSummary,
  ExportDetailSummary,
  ExportRawDetailSummary,
  ExportRawSummary,
  ExportSummary,
  ImportDetailSummary,
  ImportRawDetailSummary,
  ImportRawSummary,
  ImportSummary,
  InventoryAdjustmentSummary,
  InventorySummary,
  OrderSummary,
  PriceFluctuationDetail,
  TransferSummary,
};
